<template>
  <div>
    <h4 class="info-text">
      Quel est le montant total des versements réalisés jusqu'à présent sur
      votre
      {{
        mode === "pea"
          ? "PEA"
          : mode === "crypto"
          ? "compte crypto (en USD)"
          : "compte US (en USD)"
      }}
      ?
    </h4>
    <div class="row justify-content-center mt-5">
      <div class="col-sm-3">
        <base-input
          name="initialCapital"
          required
          placeholder="Phone"
          v-model="model.initialCapital"
          v-validate="modelValidations.initialCapital"
          :error="getError('initialCapital')"
          addon-left-icon="tim-icons icon-money-coins"
        >
        </base-input>
      </div>
    </div>
    <div class="row justify-content-center text-center">
      <div class="col-6">
        Par exemple, si vous avez réalisé un versement initial de 5000{{
          cur
        }}
        et trois autres versements de 1000{{ cur }}, indiquer le total : 8000{{
          cur
        }}.
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      model: {
        initialCapital: 15000
      },
      modelValidations: {
        initialCapital: {
          required: true,
          numeric: true
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      mode: "auth/mode"
    }),
    cur() {
      return this.mode === "pea" ? "€" : "$";
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    }
  }
};
</script>
<style></style>
